import { Component } from '@angular/core';
import { AuthService } from '../../core/auth.service';
import { ToasterService } from 'angular2-toaster';
import { Validators, FormControl } from '@angular/forms';
@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent {
  constructor(
    public auth: AuthService,
    private toastr: ToasterService,
  ) { }

  // send a password recovery email
  async resetPassword() {
    const userSnap = await this.auth.userRef.get().toPromise();
    const { email } = userSnap.data();

    const control = new FormControl(email, Validators.email);
    if (control.invalid) {
      this.toastr.pop('danger', 'Problem', 'Could not send password reset email.');
      return;
    } else {
      this.auth.resetPassword(email)
      this.toastr.pop('success', 'Success', `Check ${email} for password reset instructions`);
    }
  }
}



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/components/app-header/app-header.component.ts